import { render, staticRenderFns } from "./DSDoubleArrowLeftIcon.vue?vue&type=template&id=4e08c59c&"
import script from "./DSDoubleArrowLeftIcon.vue?vue&type=script&lang=js&"
export * from "./DSDoubleArrowLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports